var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageFeatures3Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 65,
    viewBox: "0 0 50 65",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1f2937",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.5193 65h-46.76963c.06793-.1057.1416-.2077.2207-.3053 4.29378-4.2769 8.58173-8.5536 12.86393-12.83.1021-.102.2207-.17.4074-.3227 1.8985 1.8985 3.7843 3.7843 5.8039 5.8213l14.1541-14.1542v4.7012h3.7337v-11.3538h-11.3364v3.8017h4.6497l-11.4558 11.4551c-1.8503-1.8502-3.7179-3.7503-5.6164-5.6512l-16.1745 16.1223v-62.2844h32.3813v17.1237h17.138zm-39.99831-47.9435h15.17221v-3.7338h-15.17221zm-.01661 9.5036h15.18802v-3.7179h-15.18802z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.2173 1.20483 12.0325 12.03257h-12.0325z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFeatures3Icon);
export default __webpack_public_path__ + "static/media/imageFeatures3Icon.3ed7bd6ca3b483948c03a6f5aea61ebe.svg";
export { ForwardRef as ReactComponent };